import './App.css';
import Navbar from "./components/Navbar";
import {Route, BrowserRouter as Router, Routes} from "react-router-dom";
import Home from "./components/pages/Home";
import AboutUs from "./components/pages/AboutUs";
import React from "react";
import ChurchHistory from "./components/pages/ChurchHistory";
import OurMission from "./components/pages/OurMission";

function App() {
  return (
    <>
        <Router>
            <Navbar/>
            <Routes>
                <Route path='/' element={<Home/>} />
                <Route path='/about-us' element={<AboutUs/>} />
                <Route path='/church-history' element={<ChurchHistory/>}/>
                <Route path='/our-mission' element={<OurMission/>}/>


            </Routes>
        </Router>
    </>
  );
}

export default App;
